module.exports = __webpack_public_path__ + "static/media/profile.e284fdf4.png";